<template>
    <svg :width="props.width" :height="props.height" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13 5.25V12.75C13 15.75 12.25 16.5 9.25 16.5H4.75C1.75 16.5 1 15.75 1 12.75V5.25C1 2.25 1.75 1.5 4.75 1.5H9.25C12.25 1.5 13 2.25 13 5.25Z"
            :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        <path d="M8.5 4.125H5.5" :stroke="props.color" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M6.9999 14.325C7.64193 14.325 8.1624 13.8045 8.1624 13.1625C8.1624 12.5205 7.64193 12 6.9999 12C6.35787 12 5.8374 12.5205 5.8374 13.1625C5.8374 13.8045 6.35787 14.325 6.9999 14.325Z"
            :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: 'rgb(var(--locumate-primary-color-dark))',
  },
  width: {
    type: Number,
    default: 14,
  },
  height: {
    type: Number,
    default: 18,
  },
});
</script>